import { ofType } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ADD_STAFF_ROLE_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { addStaffRoleNamesSuccess } from 'Actions';

const AddStaffRoleNamesEpic = (action$) =>
  action$.pipe(
    ofType(ADD_STAFF_ROLE_NAMES_REQUEST),
    switchMap((action) =>
      from(
        service.get(`${import.meta.env.VITE_API_DOMAIN}${action.link}`)
      ).pipe(
        map((response) => addStaffRoleNamesSuccess(response)),
        catchError((error) => {
          console.error('AddStaffRoleNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default AddStaffRoleNamesEpic;
